(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_announcement"] && !Shopify.designMode) return;
  try {
    const arvaniCountdownDeadline = Date.now() + 2 * 60 * 60 * 1000;
  let arvaniCountdownInterval;
  function updateArvaniCountdowns() {
    const seconds = Math.max(0, Math.ceil((arvaniCountdownDeadline - Date.now()) / 1000));
    const pad = value => String(value).padStart(2, '0');
    const label = [
      Math.floor(seconds / 3600),
      Math.floor((seconds % 3600) / 60),
      seconds % 60
    ].map(pad).join(':');
    document.querySelectorAll('[data-arvani-countdown]').forEach(timer => {
      timer.textContent = label;
    });
    if (seconds === 0) clearInterval(arvaniCountdownInterval);
  }
  updateArvaniCountdowns();
  arvaniCountdownInterval = setInterval(updateArvaniCountdowns, 1000);
  document.addEventListener('visibilitychange', updateArvaniCountdowns);
  document.addEventListener('shopify:section:load', updateArvaniCountdowns);
  } catch(e) { console.error(e); }
})();

})();
